import { ModelSagres } from "../../model-sagres"

export class PrestacaoDeContasMensal extends ModelSagres {
    IdPrestacaoConta: number
    Ano: number
    Mes: number
    TipoPrestacao: string
    TipoEntrega: string
    DataEntrega: Date
    DsStatusPc: number
    UsuarioEntrega: string
    NomeArquivo: string
    Descricao: string

    /**
     * Trata os dados recebidos pela API. Não execute em outras situações
     * @since 20220926
     */
    tratarDadosDaAPI(): void {
        /* if (typeof (this as any).Ref !== 'undefined') {
            this.Referencia = (this as any).Ref
        } */
        if (this.DataEntrega) {
            this.DataEntrega = new Date(this.DataEntrega)
        }
    }
}